import { latestVideos } from '@/mocks/homepage';
import VideoCard from '@/components/feature/VideoCard';

export default function LatestSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新的最新视频内容</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {latestVideos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              category={video.category}
              categorySlug={video.categorySlug}
              imageUrl={video.imageUrl}
              duration={video.duration}
              views={video.views}
              date={video.date}
              isNew={video.isNew}
            />
          ))}
        </div>
      </div>
    </section>
  );
}